import React from 'react'
import injectSheet from 'react-jss'
import styles from './info-message.styles'
import InfoIcon from 'react-icons/lib/fa/info-circle'

const InfoMessage = ({ classes, title }) => (
  <p className={classes.message}>
    <InfoIcon className={classes.icon} />
    You are sharing "<strong>{title}</strong>
  </p>
)

export default injectSheet(styles)(InfoMessage)
